module.exports = __webpack_public_path__ + "img/USA_ANIMAL_FATS.503b04b9.png";